var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"silentbox-group"}},[_vm._t("default"),_c('silentbox-overlay')],2)}
var staticRenderFns = []

export { render, staticRenderFns }